<template>
    <div class="report-container">
        <el-card class="box-cardss">
            <template #header>
                <div class="card-header">
                    <span>广告数据报表</span>
                    <div class="header-controls">
                        <el-date-picker v-model="selectedDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions" @change="handleDateChange" />
                        <el-button type="primary" @click="fetchData" :loading="loading" icon="el-icon-refresh">
                            查询
                        </el-button>
                        <el-button type="primary" @click="openTokenDialog" icon="el-icon-setting">
                            token信息管理
                        </el-button>
                        <el-button @click="exportData" :disabled="reportData.length === 0" icon="el-icon-download">
                            导出
                        </el-button>
                    </div>
                </div>
            </template>

            <el-alert v-if="error" :title="`加载失败: ${error}`" type="error" show-icon closable class="error-alert">
                <el-button type="text" @click="fetchData">重试</el-button>
            </el-alert>

            <div class="data-info">
                <span>共 {{ reportData.length }} 条数据 (已筛选曝光>0)</span>
            </div>

            <el-table v-loading="loading" :data="reportData" border stripe style="width: 100%"
                :default-sort="{ prop: 'cost', order: 'descending' }" empty-text="暂无数据">
                <el-table-column prop="manager_name" label="经理账户" min-width="140" />
                <el-table-column prop="nick_name" label="客户备注" min-width="120" />
                <el-table-column prop="advertiser_id" label="账户ID" min-width="180" />

                <el-table-column prop="show_count" label="曝光量" min-width="100" align="right" sortable>
                    <template #default="{ row }">
                        <span :class="{ 'highlight-number': row.show_count > 0 }">
                            {{ formatNumber(row.show_count) }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="click_count" label="点击量" min-width="100" align="right">
                    <template #default="{ row }">
                        {{ formatNumber(row.click_count) }}
                    </template>
                </el-table-column>

                <el-table-column prop="cpc" label="点击均价" min-width="100" align="right">
                    <template #default="{ row }">
                        {{ formatCurrency(row.cpc) }}
                    </template>
                </el-table-column>

                <el-table-column prop="form_submit_count" label="表单提交量" min-width="120" align="right">
                    <template #default="{ row }">
                        {{ formatNumber(row.form_submit_count) }}
                    </template>
                </el-table-column>

                <el-table-column prop="form_submit_cost" label="表单提交成本" min-width="120" align="right">
                    <template #default="{ row }">
                        {{ formatCurrency(row.form_submit_cost) }}
                    </template>
                </el-table-column>

                <el-table-column prop="cost" label="花费" min-width="100" align="right" sortable>
                    <template #default="{ row }">
                        <span style="color: #f56c6c; font-weight: bold;">
                            {{ formatCurrency(row.cost) }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column prop="register_count" label="注册量" min-width="100" align="right">
                    <template #default="{ row }">
                        {{ formatNumber(row.register_count) }}
                    </template>
                </el-table-column>

                <el-table-column prop="register_cost" label="注册成本" min-width="100" align="right">
                    <template #default="{ row }">
                        {{ formatCurrency(row.register_cost) }}
                    </template>
                </el-table-column>

                <el-table-column prop="pay_count" label="付费量" min-width="100" align="right">
                    <template #default="{ row }">
                        {{ formatNumber(row.pay_count) }}
                    </template>
                </el-table-column>

                <el-table-column prop="pay_cost" label="付费成本" min-width="100" align="right">
                    <template #default="{ row }">
                        {{ formatCurrency(row.pay_cost) }}
                    </template>
                </el-table-column>


            </el-table>

            <!-- 汇总信息 -->
            <!-- <el-card v-if="reportData.length > 0" class="summary-card">
          <div class="summary-content">
            <el-statistic title="总花费" :value="totalCost" :precision="2" prefix="¥" />
            <el-statistic title="总曝光" :value="totalShow" />
            <el-statistic title="总点击" :value="totalClick" />
            <el-statistic title="总注册" :value="totalRegister" />
            <el-statistic title="总付费" :value="totalPay" />
            <el-statistic title="平均点击率" :value="avgCtr" :precision="2" suffix="%" />
          </div>
        </el-card> -->
            <el-affix target=".box-cardss" :offset="20" position="bottom">
                <el-card v-if="reportData.length > 0" class="floating-summarydd">
                    <div class="summary-contentdd">
                        <el-statistic title="总花费" :value="totalCost" :precision="2" prefix="¥" />
                        <el-statistic title="总曝光" :value="totalShow" />
                        <el-statistic title="总点击" :value="totalClick" />
                        <el-statistic title="总注册" :value="totalRegister" />
                        <el-statistic title="总付费" :value="totalPay" />
                        <el-statistic title="点击率" :value="avgCtr" :precision="2" suffix="%" />
                    </div>
                </el-card>
            </el-affix>
        </el-card>
        <el-dialog title="Token信息管理" :visible.sync="tokenDialogVisible" width="80%" :close-on-click-modal="false">
            <div class="token-management">
                <!-- 查询条件 -->
                <el-form :inline="true" :model="tokenQuery" class="demo-form-inline">
                    <el-form-item label="经理账户">
                        <el-input v-model="tokenQuery.manager_name" placeholder="请输入经理账户" clearable
                            @change="fetchTokenList"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="fetchTokenList">查询</el-button>
                        <el-button @click="resetTokenQuery">重置</el-button>
                    </el-form-item>
                </el-form>

                <!-- token表格 -->
                <el-table v-loading="tokenLoading" :data="tokenList" border stripe style="width: 100%">
                    <!-- <el-table-column prop="id" label="ID" width="80" /> -->
                    <el-table-column prop="managerName" label="经理账户" min-width="120" />
                    <el-table-column prop="accessToken" label="Access Token" min-width="200" show-overflow-tooltip />
                    <el-table-column prop="refreshToken" label="Refresh Token" min-width="200" show-overflow-tooltip />
                    <!-- <el-table-column prop="expires_in" label="过期时间" min-width="120">
                        <template #default="{ row }">
                            {{ formatTime(row.expires_in) }}
                        </template>
                    </el-table-column> -->

                    <el-table-column label="操作" width="150" fixed="right">
                        <template #default="{ row }">
                            <el-button size="mini" @click="editToken(row)">编辑</el-button>
                            <el-button size="mini" type="danger" @click="deleteToken(row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <el-pagination @size-change="handleTokenSizeChange" @current-change="handleTokenCurrentChange"
                    :current-page="tokenQuery.page" :page-sizes="[10, 20, 50, 100]" :page-size="tokenQuery.size"
                    layout="total, sizes, prev, pager, next, jumper" :total="tokenTotal"
                    style="margin-top: 20px; text-align: right;">
                </el-pagination>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="tokenDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 编辑token弹窗 -->
        <el-dialog title="编辑Token信息" :visible.sync="editDialogVisible" width="50%" :close-on-click-modal="false">
            <el-form :model="tokenForm" label-width="100px">
                <el-form-item label="经理账户">
                    <el-input v-model="tokenForm.manager_name"></el-input>
                </el-form-item>
                <el-form-item label="Access Token">
                    <el-input v-model="tokenForm.access_token" type="textarea" :rows="3"></el-input>
                </el-form-item>
                <!-- <el-form-item label="Refresh Token">
                    <el-input v-model="tokenForm.refreshToken" type="textarea" :rows="3"></el-input>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveToken" :loading="saveLoading">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import axios from 'axios';

export default {
    name: 'AdReport',
    data() {
        return {
            reportData: [],
            loading: false,
            error: null,
            selectedDate: this.getDefaultDate(0),
            pickerOptions: {
                disabledDate: this.disabledDate
            },
            tokenDialogVisible: false,
            editDialogVisible: false,
            tokenLoading: false,
            saveLoading: false,
            tokenList: [],
            tokenTotal: 0,
            tokenQuery: {
                manager_name: '',
                page: 1,
                size: 10
            },
            tokenForm: {
                id: '',
                manager_name: '',
                access_token: '',
                refresh_token: '',
                expires_in: '',
                updateTime: ''
            }
        };
    },
    computed: {
        totalCost() {
            return this.reportData.reduce((sum, item) => {
                // console.log(item);
                // console.log(item.report_data.data.list_summary.cost);
                const cost = parseFloat(item.cost) || 0;
                return sum + cost;
            }, 0);
        },
        totalShow() {
            return this.reportData.reduce((sum, item) => {
                const showCount = parseInt(item.show_count) || 0;
                return sum + showCount;
            }, 0);
        },
        totalClick() {
            return this.reportData.reduce((sum, item) => {
                const clickCount = parseInt(item.click_count) || 0;
                return sum + clickCount;
            }, 0);
        },
        totalRegister() {
            return this.reportData.reduce((sum, item) => {
                const registerCount = parseInt(item.register_count) || 0;
                return sum + registerCount;
            }, 0);
        },
        totalPay() {
            return this.reportData.reduce((sum, item) => {
                const payCount = parseInt(item.pay_count) || 0;
                return sum + payCount;
            }, 0);
        },
        avgCtr() {
            const click = Number(this.totalClick) || 0;
            const show = Number(this.totalShow) || 0;
            if (!show) return 0;
            return Number(((click / show) * 100).toFixed(2)); // 注意这里要加 Number()
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        openTokenDialog() {
            this.tokenDialogVisible = true;
            this.fetchTokenList();
        },

        // 获取token列表
        async fetchTokenList() {
            this.tokenLoading = true;
            try {
                const response = await axios.get('https://control.zjwec.cn/api/huawei/oauth/token/page', {
                    params: this.tokenQuery
                });
                console.log(response);
                this.tokenList = response.data.records || []
                this.tokenTotal = response.data.total || 0;
            } catch (err) {
                console.error('获取token列表失败:', err);
                this.$message.error('获取token列表失败');
            } finally {
                this.tokenLoading = false;
            }
        },

        // 重置查询条件
        resetTokenQuery() {
            this.tokenQuery = {
                manager_name: '',
                page: 1,
                size: 10
            };
            this.fetchTokenList();
        },

        // 分页大小改变
        handleTokenSizeChange(size) {
            this.tokenQuery.size = size;
            this.tokenQuery.page = 1;
            this.fetchTokenList();
        },

        // 当前页改变
        handleTokenCurrentChange(page) {
            this.tokenQuery.page = page;
            this.fetchTokenList();
        },

        // 编辑token
        editToken(row) {
            this.tokenForm = {
                id: row.id,
                manager_name: row.managerName,
                access_token: row.accessToken,
                // refresh_token: row.refresh_token,
                // expires_in: row.expires_in,
                // updateTime:row.updateTime
            };
            this.editDialogVisible = true;
        },

        // 保存token
        async saveToken() {
            this.saveLoading = true;
            try {
                await axios.put('https://control.zjwec.cn/api/huawei/oauth/token/update', this.tokenForm);
                this.$message.success('保存成功');
                this.editDialogVisible = false;
                this.fetchTokenList();
            } catch (err) {
                console.error('保存token失败:', err);
                this.$message.error('保存失败');
            } finally {
                this.saveLoading = false;
            }
        },

        // 删除token
        deleteToken(row) {
            this.$confirm('确定要删除这条token信息吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    await axios.delete(`https://control.zjwec.cn/api/huawei/oauth/token/delete/${row.id}`);
                    this.$message.success('删除成功');
                    this.fetchTokenList();
                } catch (err) {
                    console.error('删除token失败:', err);
                    this.$message.error('删除失败');
                }
            }).catch(() => { });
        },

        // 格式化时间
        formatTime(timestamp) {
            if (!timestamp) return '-';
            return new Date(timestamp).toLocaleString();
        },
        // 处理数据，提取需要的字段并计算衍生字段
        processData(items) {
            return items.map(item => {
                const report = item.report_data.data.list_summary || {};
                const showCount = parseInt(report.show_count) || 0;
                const clickCount = parseInt(report.click_count) || 0;
                const cost = parseFloat(report.cost) || 0;
                const registerCount = parseInt(report.register_count) || 0;
                const payCount = parseInt(report.pay_count) || 0;
                const formSubmitCount = parseInt(report.form_submit_count) || 0;

                // 计算衍生字段
                const cpc = clickCount > 0 ? cost / clickCount : 0;
                const registerCost = registerCount > 0 ? cost / registerCount : 0;
                const payCost = payCount > 0 ? cost / payCount : 0;
                const formSubmitCost = formSubmitCount > 0 ? cost / formSubmitCount : 0;

                return {
                    manager_name: item.manager_name,
                    nick_name: item.nick_name,
                    advertiser_id: item.advertiser_id,
                    show_count: showCount,
                    click_count: clickCount,
                    cpc: cpc,
                    cost: cost,
                    register_count: registerCount,
                    register_cost: registerCost,
                    pay_count: payCount,
                    pay_cost: payCost,
                    form_submit_count: formSubmitCount,
                    form_submit_cost: formSubmitCost
                };
            });
        },

        async fetchData() {
            this.loading = true;
            this.error = null;

            try {
                if (!this.selectedDate) {
                    this.error = '请选择日期';
                    this.loading = false;
                    return;
                }

                const response = await axios.get('https://control.zjwec.cn/api/huawei/oauth/advertisers/report', {
                    params: {
                        start_date: this.selectedDate,
                        end_date: this.selectedDate
                    }
                });

                // 根据实际数据结构处理数据
                const rawData = response.data.data || response.data || [];

                // 处理数据并筛选曝光>0
                const processedData = this.processData(rawData);
                this.reportData = processedData.filter(item => item.show_count > 0);

            } catch (err) {
                console.error('获取数据失败:', err);
                this.error = err.message || '网络请求失败';
            } finally {
                this.loading = false;
            }
        },

        handleDateChange() {
            if (this.selectedDate) {
                this.fetchData();
            }
        },

        disabledDate(time) {
            return time.getTime() > Date.now();
        },

        formatNumber(num) {
            if (!num && num !== 0) return '-';
            return parseInt(num).toLocaleString();
        },

        formatCurrency(amount) {
            if (!amount && amount !== 0) return '-';
            return '¥' + parseFloat(amount).toFixed(2);
        },

        getDefaultDate(offset = 0) {
            const date = new Date();
            date.setDate(date.getDate() + offset);
            return date.toISOString().split('T')[0];
        },

        exportData() {
            const headers = [
                '经理账户', '客户备注', '账户ID', '曝光量', '点击量', '点击均价',
                '花费', '注册量', '注册成本', '付费量', '付费成本', '表单提交量', '表单提交成本'
            ];

            // 详细数据
            const detailRows = this.reportData.map(item => [
                item.manager_name || '',
                item.nick_name || '',
                item.advertiser_id,
                item.show_count || 0,
                item.click_count || 0,
                item.cpc ? parseFloat(item.cpc).toFixed(2) : '0.00',
                item.cost ? parseFloat(item.cost).toFixed(2) : '0.00',
                item.register_count || 0,
                item.register_cost ? parseFloat(item.register_cost).toFixed(2) : '0.00',
                item.pay_count || 0,
                item.pay_cost ? parseFloat(item.pay_cost).toFixed(2) : '0.00',
                item.form_submit_count || 0,
                item.form_submit_cost ? parseFloat(item.form_submit_cost).toFixed(2) : '0.00'
            ]);

            // 汇总数据
            const summaryRows = [
                ['总花费', '总曝光', '总点击', '总注册', '总付费', '点击率'],
                [
                    `${this.totalCost.toFixed(2)}`,
                    this.totalShow.toString(),
                    this.totalClick.toString(),
                    this.totalRegister.toString(),
                    this.totalPay.toString(),
                    `${this.avgCtr}%`,

                ]
            ];

            const csvContent = [
                headers.join(','),
                ...detailRows.map(row => row.join(',')),
                '', // 空行分隔
                ...summaryRows.map(row => row.join(','))
            ].join('\n');

            const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `广告报表_${this.selectedDate}.csv`;
            link.click();
        }
    }
};
</script>
  
<style scoped>
.token-management {
    padding: 0 10px;
}

.demo-form-inline {
    margin-bottom: 20px;
}

.report-container {
    padding: 20px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-controls {
    display: flex;
    gap: 10px;
    align-items: center;
}

.summary-card {
    margin-top: 20px;
}

.summary-contentdd {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 15px;
}

.error-alert {
    margin-bottom: 20px;
}

.data-info {
    margin-bottom: 15px;
    color: #666;
    font-size: 14px;
}

.highlight-number {
    color: #409EFF;
    font-weight: bold;
}

.box-cardss {
    min-height: 500px;
}

.floating-summarydd {
    margin-top: 20px;
    box-shadow: 0 -2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px 8px 0 0;
}

.summary-contentdd {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 15px;
    padding: 16px 0;
}

/* 响应式设计 */
/* @media (max-width: 1200px) {
    .summary-content {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .summary-content {
        grid-template-columns: repeat(2, 1fr);
    }
} */
</style>


// WEBPACK FOOTER //
// src/components/huawei/hwReport.vue